import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/skeleton/skeleton.component.js'

const tagName = 'dap-ds-skeleton'

/**
 * `dap-ds-skeleton`
 * @summary A skeleton loader component for displaying placeholder content while loading.
 * @element dap-ds-skeleton
 * @title - Skeleton
 *
 * @example Basic Usage
 * ```html
 * <dap-ds-skeleton></dap-ds-skeleton>
 * <dap-ds-skeleton variant="circular"></dap-ds-skeleton>
 * <dap-ds-skeleton variant="rectangular" width="200px" height="100px"></dap-ds-skeleton>
 * <dap-ds-skeleton animation="custom" custom-keyframes="0% { transform: scale(1); } 50% { transform: scale(1.1); } 100% { transform: scale(1); }"></dap-ds-skeleton>
 * ```
 *
 * @csspart base - The main skeleton container.
 *
 * @cssprop --dds-skeleton-color - The base color of the skeleton.
 * @cssprop --dds-skeleton-animation-duration - Duration of the loading animation.
 * @cssprop --dds-skeleton-border-radius - Border radius for rectangular skeletons.
 * @cssprop --dds-skeleton-text-spacing - Spacing between text lines in text variant.
 * @cssprop --dds-skeleton-animation-timing-function - Timing function for the loading animation.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSSkeleton',
})

export default reactWrapper
